export default __webpack_public_path__ + "static/media/usc_posh.4d7455c9.png";